/* eslint-disable no-useless-catch */

import axiosMethods from '@/api/apiManager';
import * as APPDATA from '@/constants/pcConstAppData';

export async function GetCalibrationHistoryList() {
  try {
    const response = await axiosMethods.get(APPDATA.API.GET_CALIBRATION_HISTORY);
    const {data} = response;
    return data;
  } catch (error) {
    throw error;
  }
}

export async function FactoryResetCalibration() {
  try {
    const response = await axiosMethods.put(APPDATA.API.CALIBRATION_FACTORY_RESET);
    const {data} = response;
    return data;
  } catch (error) {
    throw error;
  }
}

export async function SetCalibrationHistoryList(params) {
  try {
    const response = await axiosMethods.put(APPDATA.API.CALIBRATE_FROM_HISTORY, params);
    const {data} = response;
    return data;
  } catch (error) {
    throw error;
  }
}
export async function DeleteCalibrationHistory(params) {
  try {
    const response = await axiosMethods.put(APPDATA.API.DELETE_HISTORY, params);
    const {data} = response;
    return data;
  } catch (error) {
    throw error;
  }
}

// export async function DoTare(params) {
// 	try {
// 		const response = await axiosMethods.put(APPDATA.API.TARE_REFERENCE, params);
// 		const data = response.data;
// 		return data;
// 	} catch (error) {
// 		throw error;
// 	}
// }

export async function DoTare(params) {
  try {
    const response = await axiosMethods.put(APPDATA.API.DO_TARE, params);
    const {data} = response;
    return data;
  } catch (error) {
    throw error;
  }
}

export async function IsTareDone() {
  try {
    const response = await axiosMethods.get(APPDATA.API.TARE + APPDATA.API.IS_DONE);
    const {data} = response;
    return data;
  } catch (error) {
    throw error;
  }
}
